/* Elements
 - Unclassed HTML elements, last layer to have type selectors
 =========================================================================== */

import { css } from 'styled-components';
import form from './form';
import heading from './heading';
import image from './image';
import link from './link';
import list from './list';
import page from './page';
import table from './table';
import typography from './typography';

export default css`
  ${form};
  ${heading};
  ${image};
  ${link};
  ${list};
  ${page};
  ${table};
  ${typography};
`;
